import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Settings } from '../../models/admin-models/settings.model';
import { Filter } from '../../models/filter.model';
import { OfferNumber } from './offer-number.service';
import { map, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class SettingsService {

    constructor(private httpClient: HttpClient) { }

    getSettings() {
        return this.httpClient.get('api/settings/get').toPromise();
    }

    updateSetting(settings: Settings) {
        return this.httpClient.post('api/settings/edit', settings.data).toPromise();
    }

    getOfferNumbers(filter: Filter) {
        return this.httpClient.post('api/offernumbers/gridview', filter.data)
            .pipe(
                map((res: any) => {
                    return res.data;
                }),
                catchError((error) => {
                    return throwError(error);
                })
            )
    }

    updateOfferNumber(offerNumber: OfferNumber) {
        return this.httpClient.post('api/offernumbers/create', offerNumber.data).toPromise();
    }

    editOfferNumber(offerNumber: OfferNumber) {
        return this.httpClient.post('api/offernumbers/edit', offerNumber.data).toPromise();
    }

}